// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
export const getTypedObjectKeys = <T extends {}>(o: T): Array<keyof T> => <Array<keyof T>>Object.keys(o);
